<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Date Filters Section -->
            <div class="row mb-3">
              <div class="col-md-3">
                <label class="form-label">Date From</label>
                <input v-model="datefrom" type="date" class="form-control" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Date To</label>
                <input v-model="dateto" type="date" class="form-control" />
              </div>
              <div class="col-md-3 d-flex align-items-end">
                <button class="btn btn-info me-2" @click="FilterData">
                  <i class="mdi mdi-filter"></i> Apply Filter
                </button>
                <button class="btn btn-secondary" @click="clearDateFilter">
                  <i class="mdi mdi-filter-remove"></i> Clear
                </button>
              </div>
              <div class="col-md-3 d-flex align-items-end justify-content-end">
                <button class="btn btn-danger" @click="exportToPDF">
                  <i class="mdi mdi-file-pdf"></i> Export to PDF
                </button>
              </div>
            </div>

            <hr />

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            
            <div class="table-responsive">
              <b-table
                :items="filteredItems"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
                striped
                hover
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ (currentPage - 1) * perPage + data.index + 1 }}
              </template>
              <template #cell(telephone)="data">
                0{{ data.item.telephone }}
              </template>
              <template #cell(updated_at)="data">
                {{ formatDate(data.item.updated_at) }}
              </template>
              <template #cell(actions)="data">
                <router-link :to="{ path: '/testresults',  query: { id: data.item.visit_id }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-square-edit-outline"></i> results</router-link>
              </template>
              </b-table>
            </div>
            
            <!-- Statistics Section -->
            <div class="row mt-3" v-if="filteredListLength > 0">
              <div class="col-md-12">
                <div class="alert alert-info">
                  <strong>Summary Statistics:</strong><br>
                  Total Patients: {{ filteredListLength }} | 
                  Male: {{ maleCount }} | 
                  Female: {{ femaleCount }} |
                  Date Range: {{ datefrom || 'All' }} to {{ dateto || 'All' }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="filteredListLength" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="edit-item" centered :title=patient_name title-class="font-14" hide-footer>
        <form @submit.prevent="editItem">
            <div class="form-group mb-2">
            <input v-model="patient_id" type="hidden">
            <input v-model="visit_id" type="hidden">
            <table class="table table-sm mt-2" style="color: black;" density="compact">
            <thead><tr><th>Test</th><th>Sample</th></tr></thead>
              <tbody>
              <tr v-for="item in labtests" :key="item.id">
                <td>{{ item.service.name }}</td>
                <td><multiselect v-model="sample" :options="labsamples" label="name"></multiselect></td>
              </tr>
              </tbody>
            </table>
            <label>Picked From (where)</label>
            <input v-model="pickedfrom" type="text" placeholder="Place where sample was taken from" class="form-control" />
            <label>Picked By</label>
            <multiselect v-model="pickedby" :options="users" label="full_name"></multiselect>
            <label>Date Picked</label>
            <input v-model="datepicked" type="date" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-item')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>
  </Layout>
</template>

<script>
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { labPatientMethods, labPatientComputed} from "@/state/helpers";

export default {
  page: {
    title: "Enter Test Results",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader,Multiselect
  },
  data() {
    return {
      title: "Enter Test Results",
      items: [ {text: "Dashboard",to: "/",}, {text: "Enter Test Results",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: ['name', 'gender', 'telephone', 'address'],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true, sortable: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'name', label: 'Name', visible: true, sortable: true },
          { key: 'gender', label: 'Gender', visible: true, sortable: true },
          { key: 'telephone', label: 'Telephone', visible: true, sortable: true },
          { key: 'address', label: 'Address', visible: true, sortable: true },
          { key: 'updated_at', label: 'Visit Date', visible: true, sortable: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      patient_id:'',
      patient_name:'',
      visit_id:'',
      datepicked:new Date().toLocaleDateString('fr-CA'),
      service_id:'',
      sample:'',
      pickedfrom:'',
      pickedby:'',
      labtests:[],
      
      // Date filters
      datefrom: '',
      dateto: '',
      appliedDateFrom: '',
      appliedDateTo: ''
    };
  },
  computed: {
    ...labPatientComputed,
    List() { return this.labpatients.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.labpatients.map((d) => ({...d }))},
    IsBusy() { return this.labpatients.length === 0 },
    
    // Filtered items based on date range
    filteredItems() {
      let items = [...this.labpatients];
      
      // Apply date filter
      if (this.appliedDateFrom && this.appliedDateTo) {
        items = items.filter(item => {
          if (!item.updated_at) return false;
          const visitDate = new Date(item.updated_at);
          const fromDate = new Date(this.appliedDateFrom);
          const toDate = new Date(this.appliedDateTo);
          // Set time to beginning/end of day for accurate comparison
          fromDate.setHours(0, 0, 0, 0);
          toDate.setHours(23, 59, 59, 999);
          return visitDate >= fromDate && visitDate <= toDate;
        });
      } else if (this.appliedDateFrom) {
        items = items.filter(item => {
          if (!item.updated_at) return false;
          const visitDate = new Date(item.updated_at);
          const fromDate = new Date(this.appliedDateFrom);
          fromDate.setHours(0, 0, 0, 0);
          return visitDate >= fromDate;
        });
      } else if (this.appliedDateTo) {
        items = items.filter(item => {
          if (!item.updated_at) return false;
          const visitDate = new Date(item.updated_at);
          const toDate = new Date(this.appliedDateTo);
          toDate.setHours(23, 59, 59, 999);
          return visitDate <= toDate;
        });
      }
      
      return items;
    },
    
    filteredListLength() {
      return this.filteredItems.length;
    },
    
    maleCount() {
      return this.filteredItems.filter(item => item.gender === 'Male').length;
    },
    
    femaleCount() {
      return this.filteredItems.filter(item => item.gender === 'Female').length;
    }
  },
  mounted() {
    this.fetchLabPatients();
    this.TotalRows = this.labpatients.length;
    this.isBusy = false;
  },
  methods: {
    ...labPatientMethods,
    
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;     
    },
    
    formatDate(date) {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString();
    },
    
    FilterData() {
      this.appliedDateFrom = this.datefrom;
      this.appliedDateTo = this.dateto;
      this.currentPage = 1;
    },
    
    clearDateFilter() {
      this.datefrom = '';
      this.dateto = '';
      this.appliedDateFrom = '';
      this.appliedDateTo = '';
      this.currentPage = 1;
    },
    
    // Export to PDF
    exportToPDF() {
      if (this.filteredListLength === 0) {
        this.$toast?.warning("No data to export!") || alert("No data to export!");
        return;
      }
      
      const printWindow = window.open('', '_blank');
      const currentDate = new Date().toLocaleString();
      
      // Generate table rows
      let tableRows = '';
      this.filteredItems.forEach((item, index) => {
        tableRows += `
          <tr>
            <td style="padding: 8px; border: 1px solid #ddd;">${index + 1}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">${this.escapeHtml(item.name)}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">${item.gender || 'N/A'}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">0${item.telephone || ''}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">${this.escapeHtml(item.address || 'N/A')}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">${this.formatDate(item.updated_at)}</td>
          </tr>
        `;
      });
      
      // Write the HTML content
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Lab Patients Report</title>
          <style>
            @media print {
              body {
                margin: 0;
                padding: 20px;
              }
              .no-print {
                display: none;
              }
              .print-container {
                display: block;
              }
              table {
                page-break-inside: avoid;
              }
              thead {
                display: table-header-group;
              }
            }
            
            body {
              font-family: Arial, Helvetica, sans-serif;
              padding: 20px;
              margin: 0;
            }
            
            .print-header {
              text-align: center;
              margin-bottom: 20px;
              padding-bottom: 10px;
              border-bottom: 2px solid #333;
            }
            
            .print-header h1 {
              color: #2c3e50;
              margin: 0 0 10px 0;
            }
            
            .print-header p {
              color: #7f8c8d;
              margin: 5px 0;
            }
            
            .summary-box {
              margin-bottom: 20px;
              padding: 15px;
              background-color: #f5f5f5;
              border-radius: 5px;
            }
            
            .summary-box p {
              margin: 5px 0;
              font-size: 13px;
            }
            
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
              font-size: 12px;
            }
            
            th {
              background-color: #34495e;
              color: white;
              padding: 10px;
              border: 1px solid #2c3e50;
              text-align: left;
            }
            
            td {
              padding: 8px;
              border: 1px solid #ddd;
            }
            
            tr:nth-child(even) {
              background-color: #f9f9f9;
            }
            
            .print-footer {
              text-align: center;
              margin-top: 30px;
              padding-top: 20px;
              border-top: 1px solid #ddd;
              font-size: 10px;
              color: #7f8c8d;
            }
            
            .print-button {
              text-align: center;
              margin-bottom: 20px;
            }
            
            button {
              background-color: #3498db;
              color: white;
              border: none;
              padding: 10px 20px;
              border-radius: 5px;
              cursor: pointer;
              font-size: 14px;
              margin: 0 5px;
            }
            
            button:hover {
              background-color: #2980b9;
            }
            
            .text-center {
              text-align: center;
            }
          </style>
        </head>
        <body>
          <div class="print-button no-print">
            <button onclick="window.print();">🖨️ Print / Save as PDF</button>
            <button onclick="window.close();" style="background-color: #95a5a6;">❌ Close</button>
          </div>
          
          <div class="print-container">
            <div class="print-header">
              <h1>Lab Patients Report</h1>
              <p>Generated on: ${currentDate}</p>
              ${this.appliedDateFrom || this.appliedDateTo ? `
                <p>Date Range: ${this.appliedDateFrom || 'All'} to ${this.appliedDateTo || 'All'}</p>
              ` : ''}
            </div>
            
            <div class="summary-box">
              <strong>Summary Statistics:</strong><br>
              Total Patients: ${this.filteredListLength} | 
              Male: ${this.maleCount} | 
              Female: ${this.femaleCount}
            </div>
            
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Gender</th>
                  <th>Telephone</th>
                  <th>Address</th>
                  <th>Visit Date</th>
                </tr>
              </thead>
              <tbody>
                ${tableRows}
              </tbody>
             </table>
            
            <div class="print-footer">
              <p>This report was generated automatically from the Lab Management System.</p>
              <p>Printed on: ${currentDate}</p>
            </div>
          </div>
        </body>
        </html>
      `);
      
      printWindow.document.close();
      printWindow.focus();
    },
    
    escapeHtml(text) {
      if (!text) return '';
      const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      };
      return text.replace(/[&<>"']/g, function(m) { return map[m]; });
    }
  },
};
</script>

<style scoped>
.date-filter-group {
  display: flex;
  gap: 10px;
  align-items: flex-end;
}

.alert {
  margin-bottom: 0;
}
</style>